var map = {
	"./404.svg": "a14a",
	"./Customer_management.svg": "5b4f",
	"./account-set.svg": "7d0f",
	"./account.svg": "ef22",
	"./accounts.svg": "a371",
	"./address-book.svg": "921b",
	"./apparel.svg": "f009",
	"./asterisk.svg": "c8dd",
	"./bug.svg": "1779",
	"./bussiness-man.svg": "87ff",
	"./certified-supplier.svg": "cfba",
	"./chart.svg": "c829",
	"./clipboard.svg": "bc35",
	"./component.svg": "56d6",
	"./confirm.svg": "6048",
	"./dashboard.svg": "f782",
	"./discount.svg": "235a",
	"./documentation.svg": "90fb",
	"./drag.svg": "9bbf",
	"./earth.svg": "b2f0",
	"./edit.svg": "aa46",
	"./education.svg": "ad1c",
	"./email.svg": "cbb7",
	"./example.svg": "30c3",
	"./excel.svg": "6599",
	"./exit-fullscreen.svg": "dbc7",
	"./export_services.svg": "e95ac",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./fullscreen.svg": "9921",
	"./guide.svg": "6683",
	"./home.svg": "6bbe",
	"./icon.svg": "9d91",
	"./international.svg": "17df",
	"./language.svg": "2580",
	"./link.svg": "18f0",
	"./list.svg": "3289",
	"./lock.svg": "ab00",
	"./logistic-logo-fill.svg": "d5de",
	"./logistic-logo.svg": "94b9",
	"./logo-mini.svg": "8b1b",
	"./manage-order.svg": "96bc",
	"./message.svg": "47ff",
	"./mobile-terminal.svg": "a88c",
	"./money.svg": "3046",
	"./nested.svg": "dcf8",
	"./order-tracking.svg": "1257",
	"./order.svg": "11ff",
	"./orderdetails.svg": "3765",
	"./password.svg": "2a3d",
	"./pdf.svg": "f9a1",
	"./people.svg": "d056",
	"./peoples.svg": "2f11",
	"./prod-line.svg": "f190",
	"./prod.svg": "1a45",
	"./prodschedule.svg": "fd66",
	"./production_supervision.svg": "900c",
	"./qq.svg": "1430",
	"./rate-default.svg": "cf74",
	"./rate-select.svg": "f147",
	"./rejected-order.svg": "0d9c",
	"./search.svg": "8e8d",
	"./set.svg": "9873",
	"./shopping.svg": "12a5",
	"./size.svg": "8644",
	"./skill.svg": "096e",
	"./star.svg": "708a",
	"./suggest.svg": "036e",
	"./tab.svg": "8fb7",
	"./table.svg": "47f1",
	"./theme.svg": "e534",
	"./tree-table.svg": "e7c8",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./user_center.svg": "9bf1",
	"./visual.svg": "fb60",
	"./wechat.svg": "80da",
	"./zip.svg": "8aa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";